package com.happyukrainian.revision.kweb

import kotlin.js.Promise

external interface ShareData {
    var title: String?
    var text: String?
    var url: String?
}

inline val org.w3c.dom.Navigator.share: (ShareData) -> Promise<Unit>
    get() = asDynamic().share

inline val org.w3c.dom.Navigator.canShare: Boolean
    get() = asDynamic().canShare
